import React from "react";
import { Grid } from "@material-ui/core";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewOrderItem(props) {
  const orderItem = props.orderItem;
  let articleLines = props.articleLines;

  if (!articleLines) {
    articleLines = [{ elements: ["count", " x ", "article_name", "end_align", "money_sign", " ", "price"] }];
  }
  return (
    <>
      {articleLines.map((articleLine) => {
        return (
          <Grid container>
            {articleLine.elements.map((type) => {
              switch (type) {
                case "count":
                  return orderItem.count;
                case "article_name":
                case "print_name":
                  return orderItem.name;
                case "price":
                  return (orderItem.unitPrice * orderItem.count).toFixed(2);
                case "money_sign":
                  return GetCurrency();
                case "end_align":
                  return <div style={{ flex: 1, minHeight: 20 }} />;
                default:
                  return <div style={{ minHeight: 20, whiteSpace: "break-spaces" }}>{type}</div>;
              }
            })}
          </Grid>
        );
      })}
    </>
  );
}
